import {
  CButton,
  CButtonGroup,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CDataTable,
  CPagination,
  CRow,
  CLabel,
  CInputGroup,
  CInputGroupText,
  CInput,
  CSelect,
  CTooltip,
  CCollapse,
  CBadge,
  CAlert,
} from "@coreui/react";
import { useEffect, useState } from "react";
import { BsFillPlusCircleFill } from "react-icons/bs";
import { useHistory } from "react-router-dom";
import { getList } from "../../api/generics";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import moment from "moment";
import AccountingEntry, {
  ACCOUNTINGENTRYSTATUSES,
  getAccountingEntryStatusLabel,
  getccountingEntryStatusClass,
} from "../../models/accounting-entries";
import { getRoutePath } from "../../routes";
import { SUCCESS } from "../../utils/constants/tags";
import { successAlert, warningAlert } from "../utils/messages";

import {
  ACCOUNTING_ENTRIES_CREATE,
  ACCOUNTING_ENTRIES_UPDATE,
} from "../../auth/permissions";
import PermissionRequiredComponent from "../permissions/PermissionRequiredComponent";

import SingleAccountingAccountSelect from "../accounting-accounts/SingleAccountingAccountSelect";
import AccountingAccount from "../../models/accounting-accounts";

import AccountingEntriesGroup from "../../models/accounting-entries-group";
import AccountingEntriesGroupDeleteModal from "./AccountingEntriesGroupDeleteModal";
import AccountingEntriesGroupUpdateModal from "./AccountingEntriesGroupUpdateModal";
import { changeTZToUtc, formatUTCDateTime } from "../../utils/dates";
import { formatToCurrency } from "../../currency/format";
import { PYG } from "../../currency/available-currencies";
import AccountingEntryIgnoreModal from "../accounting-entries/AccountingEntryIgnoreModal";

const ITEMS_PER_PAGE = 50;

const AccountingEntryGroupList = () => {
  const fields = [
    {
      key: "id",
      _classes: ["text-center"],
      label: "Número de Asiento",
    },
    {
      key: "date",
      _classes: ["text-center"],
      label: "Fecha de Creación",
    },
    {
      key: "status",
      _classes: ["text-center"],
      label: "Estado",
    },
    {
      key: "obs",
      _classes: ["text-center"],
      label: "Obs",
    },
    {
      key: "actions",
      _classes: ["text-center"],
      label: "Acciones",
      filter: false,
    },
  ];

  const [showAccountingEntryEditModal, setShowAccountingEntryEditModal] =
    useState(false);

  const [showAccountingEntryDeleteModal, setShowAccountingEntryDeleteModal] =
    useState(false);

  const [showAccountingEntryIgnoreModal, setShowAccountingEntryIgnoreModal] =
    useState(false);

  const [accountingentriesGroup, setAccountingEntriesGroup] = useState<
    AccountingEntriesGroup | undefined
  >(undefined);
  const [search, setSearch] = useState<string>("");
  const [startDate, setStartDate] = useState<string | moment.Moment>("");
  const [endDate, setEndDate] = useState<string | moment.Moment>("");
  const [filterAccount, setFilterAccount] = useState<
    AccountingAccount | undefined
  >(undefined);
  const [filterStatus, setFilterStatus] = useState<string>("");

  const [loading, setLoading] = useState(true);

  const [accountingEntriesGroups, setAccountingEntriesGroups] = useState<
    AccountingEntriesGroup[]
  >([]);
  const [accountingentry, setAccountingEntry] = useState<
    AccountingEntry | undefined
  >(undefined);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const history = useHistory();

  const getURLParams = () => {
    let urlParams = new URLSearchParams(history.location.search);
    let page = urlParams.get("page")
      ? parseInt(urlParams.get("page") as string)
      : 1;

    if (page <= 0) {
      page = 1;
    }
    let search = urlParams.get("search") ? urlParams.get("search") : "";
    let entryStatus = urlParams.get("entry_status")
      ? urlParams.get("entry_status")
      : "";
    let startDate = urlParams.get("start_date")
      ? urlParams.get("start_date")
      : "";
    let endDate = urlParams.get("end_date") ? urlParams.get("end_date") : "";

    let accountId = urlParams.get("account_id")
      ? urlParams.get("account_id")
      : "";
    let map = new Map();
    map.set("search", search);
    map.set("page", page);
    if (startDate !== "") map.set("start_date", startDate);
    if (endDate !== "") map.set("end_date", endDate);
    if (accountId !== "") map.set("account_id", accountId);
    if (entryStatus !== "") map.set("entry_status", entryStatus);
    return map;
  };

  const fetchAccountingEntrys = async () => {
    const urlParams = getURLParams();
    const limit = ITEMS_PER_PAGE;
    const offset = ITEMS_PER_PAGE * Number(urlParams.get("page") - 1);
    const accountingentrysStatus = await getList<AccountingEntriesGroup>(
      "/accounting_entries_groups/",
      limit,
      offset,
      urlParams,
    );
    if (accountingentrysStatus.status === SUCCESS) {
      if (accountingentrysStatus.data !== undefined) {
        const count = accountingentrysStatus.data.count;
        const pages = Math.ceil((count ? count : 0) / ITEMS_PER_PAGE);
        setTotalPages(pages);
        setAccountingEntriesGroups(accountingentrysStatus.data.items);
        setCurrentPage(urlParams.get("page"));
      }
    } else {
      const message = accountingentrysStatus.detail
        ? accountingentrysStatus.detail
        : "Error desconocido";
      warningAlert(message);
    }
    setLoading(false);
  };

  const onPageChange = (page: number) => {
    setLoading(true);
    let urlParams = new URLSearchParams(history.location.search);
    let previousParams = getURLParams();
    urlParams.set(
      "search",
      previousParams.get("search") ? previousParams.get("search") : "",
    );
    if (previousParams.get("entry_status")) {
      urlParams.set("entry_status", previousParams.get("entry_status"));
    }
    if (previousParams.get("account_id")) {
      urlParams.set("account_id", previousParams.get("account_id"));
    }
    if (previousParams.get("start_date")) {
      urlParams.set("start_date", previousParams.get("start_date"));
    }
    if (previousParams.get("end_date")) {
      urlParams.set("end_date", previousParams.get("end_date"));
    }
    urlParams.set("page", page.toString());
    let url = `?${urlParams.toString()}`;
    history.push(url);
  };

  const onFilterStatusChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilterStatus(e.target.value);
  };

  const onFilterAccountChange = (newAccount: AccountingAccount | null) => {
    setFilterAccount(newAccount !== null ? newAccount : undefined);
  };

  const onStartDatehange = (value: string | moment.Moment) => {
    const newDate = value as moment.Moment;
    if (newDate === undefined || !moment(value, true).isValid()) {
      setStartDate("");
      return;
    }
    setStartDate(value);
  };

  const onEndDatehange = (value: string | moment.Moment) => {
    const newDate = value as moment.Moment;
    if (newDate === undefined || !moment(value, true).isValid()) {
      setEndDate("");
      return;
    }
    setEndDate(value);
  };

  const onAddClick = () => {
    setShowAccountingEntryEditModal(true);
  };

  const onUpdateClick = (accountingentry: AccountingEntry) => {
    setAccountingEntriesGroup(accountingentry);
    setShowAccountingEntryEditModal(true);
  };

  const onAccountingEntryEditCancel = () => {
    setAccountingEntriesGroup(undefined);
    setShowAccountingEntryEditModal(false);
  };

  const onAccountingEntryEditSuccess = () => {
    successAlert("Datos guardados con éxito!");
    setShowAccountingEntryEditModal(false);
    setAccountingEntriesGroups([]);
    setLoading(true);
    fetchAccountingEntrys();
  };

  const onDeleteClick = (accountingentry: AccountingEntry) => {
    setAccountingEntriesGroup(accountingentry);
    setShowAccountingEntryDeleteModal(true);
  };

  const onAccountingEntryDeleteCancel = () => {
    setAccountingEntriesGroup(undefined);
    setShowAccountingEntryDeleteModal(false);
  };

  const onAccountingEntryDeleteSuccess = () => {
    successAlert("Datos eliminados con éxito!");
    setShowAccountingEntryDeleteModal(false);
    setAccountingEntriesGroups([]);
    setLoading(true);
    fetchAccountingEntrys();
  };

  const onIgnoreClick = (accountingentry: AccountingEntry) => {
    setAccountingEntry(accountingentry);
    setShowAccountingEntryIgnoreModal(true);
  };

  const onAccountingEntryIgnoreCancel = () => {
    setAccountingEntry(undefined);
    setShowAccountingEntryIgnoreModal(false);
  };

  const onAccountingEntryIgnoreSuccess = () => {
    successAlert("Datos ignorados con éxito!");
    setShowAccountingEntryIgnoreModal(false);
    setAccountingEntriesGroups([]);
    setLoading(true);
    fetchAccountingEntrys();
  };

  const onSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const [details, setDetails] = useState<number[]>([]);

  useEffect(() => {
    if (accountingEntriesGroups && accountingEntriesGroups.length > 0) {
      setDetails(accountingEntriesGroups.map((_, index) => index));
    }
  }, [accountingEntriesGroups]);

  const toggleDetails = (index: number) => {
    const position = details.indexOf(index);
    let newDetails = details.slice();
    if (position !== -1) {
      newDetails.splice(position, 1);
    } else {
      newDetails = [...details, index];
    }
    setDetails(newDetails);
  };

  const onSearch = () => {
    setLoading(true);
    let urlParams = new URLSearchParams(history.location.search);
    if (search !== "") {
      urlParams.set("search", search);
    } else {
      urlParams.delete("search");
    }
    if (filterStatus !== "") {
      urlParams.set("entry_status", filterStatus);
    } else {
      urlParams.delete("entry_status");
    }
    if (filterAccount !== undefined && filterAccount.id !== undefined) {
      urlParams.set("account_id", filterAccount.id.toString());
    } else {
      urlParams.delete("account_id");
    }
    if (moment.isMoment(startDate)) {
      urlParams.set("start_date", startDate.toISOString());
    } else if (startDate !== undefined && startDate !== "") {
      urlParams.set("start_date", startDate);
    } else {
      urlParams.delete("start_date");
    }
    if (moment.isMoment(endDate)) {
      urlParams.set("end_date", endDate.toISOString());
    } else if (endDate !== undefined && endDate !== "") {
      urlParams.set("end_date", endDate);
    } else {
      urlParams.delete("end_date");
    }
    let url = `?${urlParams.toString()}`;
    history.push(url);
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      onSearch();
    }
  };

  useEffect(() => {
    fetchAccountingEntrys();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return history.listen((location) => {
      if (location.pathname !== getRoutePath("accountingEntries")) {
        return;
      }
      fetchAccountingEntrys();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);

  return (
    <>
      <CRow>
        <CCol lg="12">
          <CCard>
            <CCardHeader className="d-flex flex-row mb-3">
              <div className="p-2 ">
                <h3>Asientos Contables</h3>
              </div>
              <div className="p-2 ">
                <PermissionRequiredComponent
                  permissionName={ACCOUNTING_ENTRIES_CREATE}
                >
                  <CButton
                    color="primary"
                    className="float-right"
                    onClick={onAddClick}
                  >
                    <BsFillPlusCircleFill />
                    &nbsp; Nuevo
                  </CButton>
                </PermissionRequiredComponent>
              </div>
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol>
                  <h5>Filtros</h5>
                </CCol>
              </CRow>
              <CRow className={"mt-2"}>
                <CCol md={2}>
                  <CLabel className={"mt-2"}>Estado:</CLabel>
                </CCol>
                <CCol>
                  <CSelect
                    type="text"
                    defaultValue={filterStatus !== null ? filterStatus : ""}
                    onChange={onFilterStatusChange}
                  >
                    <option value={""}>-----</option>
                    {Object.entries(ACCOUNTINGENTRYSTATUSES).map(
                      ([key, entry], ix) => {
                        return (
                          <option key={ix} value={key}>
                            {entry.name}
                          </option>
                        );
                      },
                    )}
                  </CSelect>
                </CCol>
                <CCol md={2}>
                  <CLabel className={"mt-2"}>Cuenta Contable:</CLabel>
                </CCol>

                <CCol>
                  <SingleAccountingAccountSelect
                    value={filterAccount !== undefined ? filterAccount : null}
                    onChange={onFilterAccountChange}
                  ></SingleAccountingAccountSelect>
                </CCol>
              </CRow>

              <CRow>
                <CCol></CCol>
              </CRow>
              <CRow className={"mt-2"}>
                <CCol md={2}>
                  <CLabel className={"mt-2"}>Desde:</CLabel>
                </CCol>
                <CCol>
                  <Datetime
                    className="pl-0"
                    onChange={onStartDatehange}
                    value={startDate}
                    locale="es/PY"
                    dateFormat="DD/MM/YYYY"
                    timeFormat="HH:mm"
                    closeOnSelect={true}
                  ></Datetime>
                </CCol>
                <CCol md={2}>
                  <CLabel className={"mt-2"}>Hasta:</CLabel>
                </CCol>
                <CCol>
                  <Datetime
                    className="pl-0"
                    onChange={onEndDatehange}
                    value={endDate}
                    locale="es/PY"
                    dateFormat="DD/MM/YYYY"
                    timeFormat="HH:mm"
                    closeOnSelect={true}
                  ></Datetime>
                </CCol>
              </CRow>
              <CRow className={"mt-3"}>
                <CCol sm="12">
                  <CAlert color="primary">
                    <h5 className="mt-2">
                      ⚠️ Nota: Los filtros se aplican al asiento y a sus
                      movimientos. Podrían mostrarse asientos porque alguno de
                      sus movimientos cumple los criterios.
                    </h5>
                  </CAlert>
                </CCol>
              </CRow>
              <CRow>
                <CCol>
                  <CLabel
                    className="visually-hidden"
                    htmlFor="autoSizingInputGroup"
                  ></CLabel>
                  <CInputGroup>
                    <CInputGroupText>
                      <i className="fa fa-search"></i>
                    </CInputGroupText>
                    <CInput
                      type="text"
                      placeholder="Buscar..."
                      onChange={onSearchChange}
                      value={search}
                      onKeyDown={handleKeyDown}
                    />
                    <CButton
                      type="button"
                      color="primary"
                      variant="outline"
                      onClick={onSearch}
                    >
                      Buscar
                    </CButton>
                  </CInputGroup>
                </CCol>
              </CRow>
              <div>
                <CDataTable
                  noItemsView={
                    <h2 className="text-center">No se encontraron registros</h2>
                  }
                  addTableClasses={"table-fixed"}
                  fields={fields}
                  items={accountingEntriesGroups}
                  striped
                  border
                  loading={loading}
                  responsive
                  scopedSlots={{
                    id: (item: AccountingEntriesGroup) => {
                      return (
                        <td className="text-center">
                          {item.id ? `Asiento N°: ${item.id}` : "-"}
                        </td>
                      );
                    },
                    obs: (item: AccountingEntriesGroup) => {
                      return (
                        <td className="text-center">
                          {item.obs ? item.obs : "-"}
                        </td>
                      );
                    },
                    status: (item: AccountingEntriesGroup) => {
                      return (
                        <td className="text-center">
                          <CBadge
                            color={
                              item.status
                                ? getccountingEntryStatusClass(item.status)
                                : undefined
                            }
                          >
                            {item.status
                              ? getAccountingEntryStatusLabel(item.status)
                              : undefined}
                          </CBadge>
                        </td>
                      );
                    },
                    date: (item: AccountingEntriesGroup) => {
                      return (
                        <td className="text-center">
                          {item.date
                            ? formatUTCDateTime(
                                changeTZToUtc(new Date(item.date)),
                              )
                            : "-"}
                        </td>
                      );
                    },
                    actions: (item: AccountingEntriesGroup, index: number) => {
                      const toggleButton = (
                        <CTooltip
                          content={
                            details.includes(index)
                              ? "Ocultar detalles"
                              : "Ver detalles"
                          }
                        >
                          <CButton
                            className="text-white"
                            color="info"
                            onClick={() => {
                              toggleDetails(index);
                            }}
                          >
                            <i
                              className={
                                details.includes(index)
                                  ? "fa fa-chevron-up"
                                  : "fa fa-chevron-down"
                              }
                            ></i>
                          </CButton>
                        </CTooltip>
                      );
                      const editButton = (
                        <PermissionRequiredComponent
                          permissionName={ACCOUNTING_ENTRIES_UPDATE}
                        >
                          <CTooltip content={"Editar"}>
                            <CButton
                              className="text-white"
                              color="warning"
                              onClick={() => {
                                onUpdateClick(item);
                              }}
                            >
                              <i className="fa fa-pencil"></i>
                            </CButton>
                          </CTooltip>
                        </PermissionRequiredComponent>
                      );

                      const deleteButton = (
                        <PermissionRequiredComponent
                          permissionName={ACCOUNTING_ENTRIES_UPDATE}
                        >
                          <CTooltip content={"Eliminar"}>
                            <CButton
                              className="text-white"
                              color="danger"
                              onClick={() => {
                                onDeleteClick(item);
                              }}
                            >
                              <i className="fa fa-trash"></i>
                            </CButton>
                          </CTooltip>
                        </PermissionRequiredComponent>
                      );

                      return (
                        <td className="text-right">
                          <CButtonGroup>
                            {toggleButton}
                            {editButton}
                            {deleteButton}
                          </CButtonGroup>
                        </td>
                      );
                    },
                    details: (item: AccountingEntriesGroup, index: number) => {
                      return (
                        <CCollapse show={details.includes(index)}>
                          <CCardBody>
                            <h5>Entradas Contables</h5>
                            {item.items && item.items.length > 0 ? (
                              <CDataTable
                                items={item.items}
                                fields={[
                                  { key: "date", label: "Fecha" },
                                  { key: "status", label: "Estado" },
                                  {
                                    key: "accountCode",
                                    label: "Cuenta Código",
                                  },
                                  {
                                    key: "accountName",
                                    label: "Cuenta Nombre",
                                  },
                                  { key: "subject", label: "Concepto" },
                                  { key: "debitAmount", label: "Debe" },
                                  { key: "creditAmount", label: "Haber" },
                                  { key: "itemActions", label: "Acciones" },
                                ]}
                                striped
                                size="sm"
                                scopedSlots={{
                                  date: (item: AccountingEntry) => {
                                    return (
                                      <td className="text-center">
                                        {item.date
                                          ? formatUTCDateTime(
                                              changeTZToUtc(
                                                new Date(item.date),
                                              ),
                                            )
                                          : "-"}
                                      </td>
                                    );
                                  },
                                  status: (item: AccountingEntry) => {
                                    return (
                                      <td className="text-center">
                                        <CBadge
                                          color={
                                            item.status
                                              ? getccountingEntryStatusClass(
                                                  item.status,
                                                )
                                              : undefined
                                          }
                                        >
                                          {item.status
                                            ? getAccountingEntryStatusLabel(
                                                item.status,
                                              )
                                            : undefined}
                                        </CBadge>
                                      </td>
                                    );
                                  },
                                  debitAmount: (item: AccountingEntry) => {
                                    return (
                                      <td className="text-center">
                                        {formatToCurrency(
                                          item.debitAmount || 0,
                                          PYG,
                                        )}
                                      </td>
                                    );
                                  },
                                  creditAmount: (item: AccountingEntry) => {
                                    return (
                                      <td className="text-center">
                                        {formatToCurrency(
                                          item.creditAmount || 0,
                                          PYG,
                                        )}
                                      </td>
                                    );
                                  },
                                  itemActions: (item: AccountingEntry) => {
                                    const ignoreButton = (
                                      <PermissionRequiredComponent
                                        permissionName={
                                          ACCOUNTING_ENTRIES_UPDATE
                                        }
                                      >
                                        <CTooltip content={"Ignorar"}>
                                          <CButton
                                            className=""
                                            color="secondary"
                                            onClick={() => {
                                              onIgnoreClick(item);
                                            }}
                                          >
                                            <i className="fa fa-thumbs-down"></i>
                                          </CButton>
                                        </CTooltip>
                                      </PermissionRequiredComponent>
                                    );

                                    return (
                                      <td className="text-right">
                                        <CButtonGroup>
                                          {item.status !== "ignored"
                                            ? ignoreButton
                                            : null}
                                        </CButtonGroup>
                                      </td>
                                    );
                                  },
                                }}
                              />
                            ) : (
                              <p className="text-muted">
                                No hay entradas contables
                              </p>
                            )}
                          </CCardBody>
                        </CCollapse>
                      );
                    },
                  }}
                />
                <div className="d-flex justify-content-center">
                  <CPagination
                    pages={totalPages}
                    activePage={currentPage}
                    onActivePageChange={(i: number) => onPageChange(i)}
                    className={totalPages < 2 ? "d-none" : ""}
                  />
                </div>
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
      <AccountingEntriesGroupUpdateModal
        show={showAccountingEntryEditModal}
        onCancel={onAccountingEntryEditCancel}
        onSuccess={onAccountingEntryEditSuccess}
        accountingEntriesGroup={accountingentriesGroup}
      />
      <AccountingEntriesGroupDeleteModal
        show={showAccountingEntryDeleteModal}
        onCancel={onAccountingEntryDeleteCancel}
        onSuccess={onAccountingEntryDeleteSuccess}
        accountingEntriesGroup={accountingentriesGroup}
      />
      <AccountingEntryIgnoreModal
        show={showAccountingEntryIgnoreModal}
        onCancel={onAccountingEntryIgnoreCancel}
        onSuccess={onAccountingEntryIgnoreSuccess}
        accountingentry={accountingentry}
      />
    </>
  );
};

export default AccountingEntryGroupList;
